import React, { useState, useRef, useEffect } from "react";
import { Button, Col, Row, DropdownItem, Dropdown, DropdownToggle, Input, DropdownMenu, UncontrolledButtonDropdown, Alert } from "reactstrap";
import { compose, withHandlers } from "recompose";
import shortid from "shortid";
import { Trans } from "react-i18next";
import { FormGroup, required, Page, onMount, withReload, withLocalForm } from "components/common";
import { withXeroErrors, LineItemsView, withContactSearch, withDocumentRenderer, withOptions, Payment } from "components";
import { withOrganisationContextConsumer } from "contexts/OrganisationContext";
import { invoiceSDKPost } from "components/common/ZatcaSendInvoice";
import { ZatcaClient, useConfirmModal } from "services";
import { getStatus } from "components/common/getStatus";
import { formatDate, formatDateTime } from "services/util";
import { Link } from "react-router-dom";
import BackButton from "components/refactoring/BackButton";
import { getOutlineStyle } from "pages/UserList/Edit";
import useNoTaxHandler from "pages/Xero/AccountsReceivable/useNoTaxHandler";
import HistoryComponent from "components/ShowHistoryComponent";
import { useBaseModal } from "services";
import { DownloadError, isValidContactDetails } from "components/common/ZatcaSelected";
import { ErrorDetailsComponent } from "components/common/ErrorDetailsComponent";

const ID_NAMES = {
  'prepayments': 'PrepaymentID',
  'payments': 'PaymentID',
  'overpayments': 'OverpaymentID',
}

export const View = ({
  item,
  History,
  LocalForm,
  onSubmit,
  xero,
  dispatch,
  handlePaymentAdded,
  handleAttachmentsChanged,
  XeroErrors,
  organisation,
  t,
  payable,
  history,
  DocumentRenderer,
  EmailDocument,
  DownloadDocument,
  PrePaymentOptions,
  selectedOrganisation,
  reload,
  setState,
  docType,
  transactionType,
  ...props
}) => {

  const cStyle = {
    status: {
      style: { fontWeight: 'bold', fontSize: '1.3em', color: '#72B566' },
    },
    common: {
      className: "pt-3 pb-3",
      xs: false,
      md: 3,
    },
  };

  const id_name = ID_NAMES[docType]

  const [items, setItems] = useState(item)

  const zatca = ZatcaClient()

  const isZatcaSubscribed = selectedOrganisation?.subscribed_features?.hesaabmodule?.includes('wpconnect')
  const pageTakeOver = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isPaymentVisible, setPaymentVisibility] = useState(false);
  const [useSimpleType, setSimpleType] = useState(false);
  const [eInvoiceStatus, setEInvoiceStatus] = useState(false);
  const [reportedList, setReportedList] = useState();
  const [zatcaData, setZatcaData] = useState(null);
  const [, toggle, MainModal] = useBaseModal()
  const [errorWindow, setErrorWindow] = useState(false);

  const { preGetInvoiceXML, preHandleSDKPost, NoTaxComponent, isSending, refreshFlag, setDocument, zatcaApps } = useNoTaxHandler(t, "prepayment", reload)
  const [selectedZatcaApp, setSelectedZatcaApp] = useState();
  const [, toggleResend, MainResendModal, setCallback] = useConfirmModal()


  const buildingNumber = null
  const clearanceStatus = useSimpleType ? "1" : "0";
  const itemType = useSimpleType ? "simplified" : "standard";
  const formattedType = itemType.charAt(0).toUpperCase() + itemType.slice(1) + " Prepayment ";
  const [callbackFunc, setCallbackFunc] = useState();

  const hasZatcaAccess = (selectedOrganisation?.country?.toLowerCase() === 'sa' && selectedOrganisation?.zatca_phase_one_enabled) || isZatcaSubscribed

  const taxAddress = items.Contact?.Addresses?.find(address => address.AddressType === 'POBOX');

  const [missFields, setMissingFields] = useState([]);


  useEffect(() => {
    if (items) {
      const mappedData = invoiceSDKPost(items, "prepayment", buildingNumber, clearanceStatus, itemType);
      setZatcaData(mappedData);
      setDocument(items)
    }
  }, [items, clearanceStatus, itemType]);

  const checkInvoiceDownload = (isWtspShare = false) => {

    if (!hasZatcaAccess) {
      return true
    }

    let contactMobile = items?.Contact?.Phones?.find((phone) => phone.PhoneType === "MOBILE")
    let isValidPhoneNumber = !isWtspShare || (contactMobile.PhoneNumber && contactMobile.PhoneCountryCode)
    let isValidContactInfo = useSimpleType || isValidContactDetails({...items.Contact})

    const missing_fields = []

    if(!isValidPhoneNumber){
      missing_fields.push('PhoneNumber')
    }

    if (!isValidContactInfo) {
      missing_fields.push('ContactInfo')
    }

    setMissingFields(missing_fields)

    if (!(isValidPhoneNumber && isValidContactInfo)) {
      toggle();
      return false;
    } else {
      return true;
    }
  };



  const zatcaFuncHandler = (params, callback) => (props = {}) => {
    callback({ ...params, ...props })
    setZatcaData({ ...params, ...props })
  }

  const sendToZatcaHandler = (invoiceSDKZatca, reporting, callback) => {
    let params = {
      ...invoiceSDKZatca,
      reporting
    }

    if (!checkInvoiceDownload()) {
      setCallbackFunc(() => zatcaFuncHandler(params, callback));
      return false
    }

    zatcaFuncHandler(params, callback)()
  }

  const checkZatcaResend = (callback) => {
    if (reportedList.reported || reportedList.cleared) {
      toggleResend()
      setCallback(() => callback)
    }
    else {
      callback()
    }
  }


  useEffect(() => {
    if (isPaymentVisible && pageTakeOver.current) {
      setTimeout(() => {
        const fullPageHeight = document.body.scrollHeight;
        window.scrollTo({
          top: fullPageHeight,
          behavior: 'smooth',
        });
      }, 200);
    }
  }, [isPaymentVisible]);


  useEffect(() => {
    setEInvoiceStatus(true)
    const fetchData = async () => {
      try {
        const responseSDK = await zatca.get(`reports/${item?.PrepaymentID}/single`);
        const reportedList = responseSDK.data;
        setEInvoiceStatus(false)
        setReportedList(reportedList);
      } catch (error) {
        console.error("Error fetching data:", error);
        setEInvoiceStatus(false)
      }
    };

    fetchData();
  }, [item?.[id_name], refreshFlag]);

  const status = (() => {
    if (reportedList?.reported) {
      return "Reported";
    } else if (reportedList?.cleared) {
      return "Cleared";
    } else if (reportedList?.complied) {
      return "Complied";
    } else {
      return false;
    }
  })();

  return (
    <div>
      <Page title={`${docType === 'prepayments' ? t('Prepayment') : t('Overpayment')} ${transactionType}`}>
        <div className="my-2 row">
          <div className="col-6">
            <BackButton />
          </div>
          {item.Type === "RECEIVE-PREPAYMENT" && 
          <div className="col-6 text-right d-flex justify-content-end align-items-center">
            <div className="inline-block mx-2">
              {isZatcaSubscribed && status ? (
                <>
                  {reportedList?.complied && <p className="mx-1 d-inline" style={getOutlineStyle('#72B566')}><Trans>Complied</Trans></p>}
                  {reportedList?.reported && <p className="mx-1 d-inline clickable" style={getOutlineStyle('#54984A')} onClick={() => setErrorWindow(true)}><Trans>Reported</Trans>
                    {reportedList?.updated_at && <span className="small"> ({formatDateTime(reportedList.updated_at)})<i className="fa fa-eye ml-1"></i></span>}
                  </p>}
                  {reportedList?.cleared && <p className="mx-1 d-inline clickable" style={getOutlineStyle('#8BD07C')} onClick={() => setErrorWindow(true)}><Trans>Cleared</Trans>
                    {reportedList?.updated_at && <span className="small"> ({formatDateTime(reportedList.updated_at)})<i className="fa fa-eye ml-1"></i></span>}
                  </p>}
                </>
              ) :
                reportedList?.updated_at ?
                  <span style={getOutlineStyle('#FFC107')} className="my-0 clickable" onClick={() => setErrorWindow(true)}><Trans>Not Reported</Trans><i className="fa fa-eye ml-1"></i></span>
                  :
                  <span style={getOutlineStyle('#FFC107')} className="my-0">----------</span>}
            </div>
            <div className="inline-block">
              {!!item?.[id_name] && (
                <div>
                  <FormGroup>
                    <Input
                      type="select"
                      id="typeSelect"
                      name="select"
                      className="py-0"
                      onChange={(e) => setSimpleType(e.target.value === 'true')}
                      value={useSimpleType}
                    >
                      <option value={true}>
                        {t('Export: Simplified Invoice')}
                      </option>
                      <option value={false}>
                        {t('Export: Tax Invoice')}
                      </option>
                    </Input>
                  </FormGroup>
                </div>
              )}
            </div>
          </div>
          }
        </div>
        <XeroErrors />
        <div className="actions-wrapper row justify-content-between">
          <div className="col-lg-12 col-xl-3 row flex-grow-0 justify-content-start mb-md-2 px-4">
            {isZatcaSubscribed && item.Type === "RECEIVE-PREPAYMENT" &&
              <div className="col flex-grow-0 px-0">
                {!isSending ?
                  (<Dropdown size="sm" color="primary" className="mx-0" isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)} disabled={isSending}>
                    <DropdownToggle color={useSimpleType ? "primary" : "secondary"} caret className="mx-0"><Trans>Report to Zatca</Trans></DropdownToggle>
                    <DropdownMenu>
                      {/* <DropdownItem onClick={() => checkZatcaResend(() => sendToZatcaHandler(zatcaData, false, preHandleSDKPost))}>
                        <Trans>Send to Compliance</Trans>
                      </DropdownItem> */}
                      {!(reportedList?.reported || reportedList?.cleared) &&
                        <DropdownItem onClick={() => checkZatcaResend(() => sendToZatcaHandler(zatcaData, true, preHandleSDKPost))}>
                          <Trans>Send to {useSimpleType ? "Clearance" : "Reporting"}</Trans>
                        </DropdownItem>
                      }
                      {reportedList?.response &&
                        <DropdownItem onClick={() => { setErrorWindow(true); }}>
                          <Trans>View Response</Trans>
                        </DropdownItem>
                      }
                      {status &&
                        <DropdownItem onClick={() => { sendToZatcaHandler(zatcaData, false, preGetInvoiceXML) }}>
                          <Trans>Download as XML</Trans>
                        </DropdownItem>
                      }
                    </DropdownMenu>
                  </Dropdown>) : (<Button disabled className="mx-0"><span className="fa fa-spinner fa-spin" /> <Trans>Sending</Trans></Button>)}
              </div>
            }
          </div>

          <div className="col-lg-12 col-xl-9 row px-4 justify-content-end">
            {!!item?.[id_name] &&
              <>
                {(item.Status === "DRAFT" || item.Status === "SUBMITTED") && (
                  <div className="col px-1 flex-grow-0">
                    <Link
                      type="button"
                      className="btn-sm btn btn-primary mx-0"
                      to={`/accounts/credit_notes/edit/${item?.[id_name]}`}>
                      <Trans>Edit</Trans>
                    </Link>
                  </div>
                )}
                {(item.Status === "PAID" || item.Status === "AUTHORISED") && (
                  <div className="col px-1 flex-grow-0">
                    <PrePaymentOptions />
                  </div>
                )}
                {item.Status === "AUTHORISED" && (
                  <div className="col px-1 flex-grow-0">
                    <div className="btn-group">
                      <button
                        type="button"
                        className="btn-sm btn btn-primary mx-0"
                        onClick={() => setPaymentVisibility(!isPaymentVisible)}>
                        {isPaymentVisible ? t('Hide Payment') : t('Add Payment')}
                      </button>
                    </div>
                  </div>
                )}
              </>
            }
          </div>
        </div>
        <LocalForm className="mt-3 inv-table"
          onSubmit={onSubmit}
          validators={{
            Contact: { required },
            Date: { required },
            "LineItems[].Description": { required },
          }}
        >
          <Row>
            <Col {...cStyle.common}>
              <FormGroup
                label={payable ? "From" : "To"}
                model=".Contact">
                <Link to={`/contacts/view/${item.Contact.ContactID}`} {...cStyle.status}>
                  {item.Contact.Name}
                </Link>
              </FormGroup>
            </Col>
            <Col {...cStyle.common}>
              <FormGroup label="Status">
                <span className="view-form-group">{getStatus(item.Status)}</span>
              </FormGroup>
            </Col>
            <Col {...cStyle.common}>
              <FormGroup label="Date" model=".Date">
                <span className="view-form-group">{formatDate(item.Date) || "---"}</span>
              </FormGroup>
            </Col>
            <Col {...cStyle.common}>
              <FormGroup label={"Invoice #"} model=".Reference">
                <span className="view-form-group">{item.Reference || '---'}</span>
              </FormGroup>
            </Col>
          </Row>
          <hr />
          <LineItemsView
            item={item}
            dispatch={dispatch}
            xero={xero}
            hideAddLines={true}
            hideAccountAndTax={true}
            removeLine={false}
            paymentText='Less Cash Refund'
            reload={reload}
          />
          <HistoryComponent historyItem={History?.HistoryRecords} type="Payments" t={t} />
        </LocalForm>
      </Page>
      {isPaymentVisible && (
        <div ref={pageTakeOver} className="centered-container">
          <Payment
            creditNote={item}
            organisation={organisation}
            onPaymentAdded={handlePaymentAdded}
            xero={xero}
            paymentType="Refund"
          />
        </div>
      )}
      <MainModal title={t('Set Invoice details')}>
        <DownloadError setInvoice={setItems} item={item} toggle={toggle} history={history} missFields={missFields} callbackFunc={callbackFunc} />
      </MainModal>

      <NoTaxComponent formattedType={formattedType} invoiceSDKZatca={zatcaData} selectedZatcaApp={selectedZatcaApp} setSelectedZatcaApp={setSelectedZatcaApp}></NoTaxComponent>

      <MainResendModal title={t('Resend Confirmation')} action={t("Confirm")}>
        <Alert color="warning">
          <Trans>This invoice is already reported to Zatca, Do you want to report it again?</Trans>
        </Alert>
      </MainResendModal>
      {errorWindow && reportedList?.response && <ErrorDetailsComponent show={errorWindow} handleClose={() => { setErrorWindow(false); }} details={reportedList.response} typeOfInv={formattedType} showWarnings={true} reload={() => { }} />}
    </div>
  )
};

const enhance = compose(
  withOrganisationContextConsumer,
  withReload(),
  onMount(({ match, xero, location, type, fetchOrganisation }) => async () => {
    const { id, docType, transactionType } = match.params
    const item = await xero
      .get(`${docType}/${id}`)
      .get("data")
      .then((x) => ({
        ...x,
        LineItems: x.LineItems.map((i) => ({
          ...i,
          _id: shortid(),
          LineItemID: i.LineItemID || i.Description,
        })),
        hasZeroTax: x?.LineItems.some((i) => (i.TaxAmount || 0) === 0),
      }));
    const History = await xero
      .get(`${docType}/${id}/History`)
      .get("data")
      .then((History) => ({
        ...History,
      }));

    const organisation = await fetchOrganisation();
    return {
      item,
      History,
      organisation,
      docType,
      transactionType,
    };
  }),
  withLocalForm({
    initialState: ({ item }) => item,
    stateKey: "item",
    formKey: "form",
  }),
  withContactSearch(),
  withXeroErrors(),
  withOptions(),
  withHandlers({
    handlePaymentAdded:
      ({ reload }) =>
        () => {
          reload();
        },
  }),
  withDocumentRenderer({
    onDownload:
      ({ item }) =>
        (getDocument) =>
          getDocument(
            {
              item,
            },
            `Transaction_${item.Reference}.pdf`
          ),
  })
);

export default enhance(View);
